import { IntegrationIconProps } from './types';

const JbYoutrack = ({ dimension }: IntegrationIconProps) => (
  <svg
    width={dimension || 32}
    height={dimension || 32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1334_1641)">
      <path
        d="M30.583 21.7143C30.4915 21.6229 24.5944 15.9543 24.5944 15.9543C24.5944 15.9543 29.0744 11.2 30.263 10.0114C30.6287 9.64572 30.9487 9.28001 31.1773 8.82286C32.823 6.03429 31.863 2.46858 29.0744 0.822864C27.0173 -0.365707 24.4573 -0.18285 22.6287 1.18858C22.3087 1.41715 22.0344 1.64572 21.7601 1.92001C21.623 2.10286 15.4058 7.77144 10.0115 12.7086L20.1144 19.1086L9.50868 31.04C8.86868 31.4972 8.22868 31.7714 7.54297 31.9086C7.68011 31.9086 7.77154 31.9086 7.90868 31.8629C10.0115 31.5429 27.9773 28.5257 28.8458 28.3429C29.8973 28.16 30.8573 27.52 31.4515 26.56C32.4573 24.9143 32.0001 22.8571 30.583 21.7143Z"
        fill="url(#paint0_linear_1334_1641)"
      />
      <path
        d="M20.9827 13.9429C20.7998 12.7086 20.1598 11.7029 19.2456 10.9714C18.2856 10.24 10.8798 2.56001 10.057 1.69143C8.77699 0.457149 6.94842 -0.228565 5.07413 0.0914346C1.87413 0.548577 -0.365869 3.56572 0.136988 6.76572C0.365559 8.36572 1.27984 9.73715 2.46842 10.6057C3.65699 11.52 12.9827 17.92 13.577 18.3771C14.537 19.1086 15.817 19.52 17.097 19.2914C19.6113 18.8343 21.3941 16.4571 20.9827 13.9429Z"
        fill="url(#paint1_linear_1334_1641)"
      />
      <path
        d="M10.5141 30.9943C10.5598 30.9943 21.1655 19.0628 21.1655 19.0628L10.4683 12.2971C6.67405 15.7714 3.15405 18.9257 2.3312 19.7028C1.82834 20.16 1.32548 20.7543 0.959767 21.3943C-1.00595 24.7771 0.13691 29.0743 3.51977 31.04C4.8912 31.8171 7.99977 32.7771 10.5141 30.9943Z"
        fill="url(#paint2_linear_1334_1641)"
      />
      <path d="M6.125 6.12567H25.8736V25.8742H6.125V6.12567Z" fill="black" />
      <path
        d="M7.95312 22.1714H15.3588V23.4057H7.95312V22.1714Z"
        fill="white"
      />
      <path
        d="M10.8801 13.6685L7.77148 8.73138H9.87434L11.7943 11.9771L13.8058 8.73138H15.8629L12.7086 13.6228V16.9142H10.8801V13.6685Z"
        fill="white"
      />
      <path
        d="M19.0162 10.3771H16.502V8.73138H23.3134V10.3771H20.7991V16.9142H19.0162V10.3771Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_1334_1641"
        x1="3.23805"
        y1="25.03"
        x2="29.3057"
        y2="13.147"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#905CFB" />
        <stop offset="0.165" stopColor="#6677F8" />
        <stop offset="0.378" stopColor="#3596F5" />
        <stop offset="0.54" stopColor="#17A9F3" />
        <stop offset="0.632" stopColor="#0CB0F2" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1334_1641"
        x1="13.8558"
        y1="12.8599"
        x2="0.488072"
        y2="1.05281"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#905CFB" />
        <stop offset="0.072" stopColor="#A554E6" />
        <stop offset="0.252" stopColor="#D641B5" />
        <stop offset="0.39" stopColor="#F43597" />
        <stop offset="0.468" stopColor="#FF318C" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1334_1641"
        x1="2.27771"
        y1="26.8274"
        x2="33.8389"
        y2="6.94078"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#905CFB" />
        <stop offset="0.165" stopColor="#6677F8" />
        <stop offset="0.378" stopColor="#3596F5" />
        <stop offset="0.54" stopColor="#17A9F3" />
        <stop offset="0.632" stopColor="#0CB0F2" />
      </linearGradient>
      <clipPath id="clip0_1334_1641">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default JbYoutrack;
